export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    groupList: [
      {
        groupIdx: 6,
        name: "NEW",
        colorCss: "bg-ivory",
        order: 1,
      },
      {
        groupIdx: 7,
        name: "BEST",
        colorCss: "bg-ivory",
        order: 1,
      },
      {
        groupIdx: 1,
        name: "푸드",
        colorCss: "bg-ivory",
        order: 1,
      },
      {
        groupIdx: 2,
        name: "차",
        colorCss: "bg-ivory",
        order: 2,
      },
      {
        groupIdx: 3,
        name: "커피",
        colorCss: "bg-pink",
        order: 3,
      },
      {
        groupIdx: 4,
        name: "에이드/주스",
        colorCss: "bg-pink",
        order: 4,
      },
      {
        groupIdx: 5,
        name: "베버리지",
        colorCss: "bg-pink",
        order: 5,
      },
      {
        groupIdx: 0,
        name: "",
        colorCss: "",
        order: 0,
      },
      {
        groupIdx: 0,
        name: "",
        colorCss: "",
        order: 0,
      },
      {
        groupIdx: 0,
        name: "",
        colorCss: "",
        order: 0,
      },
    ],
  },
};
